/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Regular expressions
export const MARKDOWN_IMG_URL_REGEX = new RegExp(/!\[[^\]]*\]\((?<filename>.*?)(?="|\))(?<optionalpart>".*")?\)/, 'g');
export const MARKDOWN_LINK_REGEX = new RegExp(/\[([^\]]+)\]\(((?:https?:\/\/|tel:)[^\s]+?)\)$/);
export const URL_REGEX = new RegExp(/^(?<scheme>[a-z][a-z0-9+.-]+):(?<authority>\/\/(?<user>[^@]+@)?(?<host>[a-z0-9.\-_~]+)(?<port>:\d+)?)?(?<path>(?:[a-z0-9-._~]|%[a-f0-9]|[!$&'()*+,;=:@])+(?:\/(?:[a-z0-9-._~]|%[a-f0-9]|[!$&'()*+,;=:@])*)*|(?:\/(?:[a-z0-9-._~]|%[a-f0-9]|[!$&'()*+,;=:@])+)*)?(?<query>\?(?:[a-z0-9-._~]|%[a-f0-9]|[!$&'()*+,;=:@]|[/?])+)?(?<fragment>#(?:[a-z0-9-._~]|%[a-f0-9]|[!$&'()*+,;=:@]|[/?])+)?$/i);
export const ALPHANUMERIC_REGEX = new RegExp(/[a-zA-Z0-9]/);
export const ALPHANUMERIC_SPACE_REGEX = new RegExp(/^[a-zA-Z0-9 ]+$/);
export const ALPHANUMERIC_HYPHEN_UNDERSCORE_REGEX = new RegExp(/^[a-zA-Z0-9-_]+$/);
export const ALPHANUMERIC_HYPHEN_UNDERSCORE_CURLY_DOT_REGEX = new RegExp(/^[a-zA-Z0-9-_.{}]+$/);
export const VARIABLE_REGEX = new RegExp(/\{\{(.*?)\}\}/g);
export const EMOJI_REGEX = new RegExp(/(?:\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\u200D|\p{Cf})/gu); // Remove emojis and non-visible characters
